module.exports = __webpack_public_path__ + "media/images/categories/headers/working-practices-03ba6c4e2af35927beb2829750ab1d8a.jpg";